export default {
  name: 'Offer Price',
  edit: {
    form: 'price-spec-input',
    label: 'Change the price',
    handler: value => value,
  },
};
